import { render, staticRenderFns } from "./UserDeactivatedInCompany.vue?vue&type=template&id=849a1198&"
import script from "./UserDeactivatedInCompany.vue?vue&type=script&lang=ts&"
export * from "./UserDeactivatedInCompany.vue?vue&type=script&lang=ts&"
import style0 from "./UserDeactivatedInCompany.vue?vue&type=style&index=0&id=849a1198&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports